import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.6 4.57 2.828 2.828-6.6 6.6H2V11.17zm.942-.943 1.415-1.414c.26-.26.682-.26.942 0l1.886 1.885c.26.26.26.683 0 .943l-1.414 1.414z"
    }, null, -1)
  ]))]))
}
export default { render: render }